import alt from 'components/Dispatcher';
import MediaSource from 'sources/MediaSource';
import MediaActions from 'actions/MediaActions';

export class MediaStore {
  constructor() {
    this.state = {
      shareTag: true,
      media: {},
      lat: 59.938043,
      lng: 30.337157,
      mediaList: [],
      categoryList: [],
      id: null,
      first: 0,
      maxCount: 20,
      page: 0,
      accessToken: null,
      postMedia: null,
      continent_id: null,
      country_id: null,
      state_id: null,
      city_id: null,
      category_id: null,
      loading: false,
      hasMore: true,
      offset: 0,
      errorMsg: ''
    }
    this.registerAsync(MediaSource);
    this.bindListeners({
      handleFetchMedia: MediaActions.FETCH_MEDIA,
      handleDeleteMedia: MediaActions.DELETE_MEDIA,
      handleFetchCategories: MediaActions.FETCH_CATEGORIES,
      handleUpdateMedia: MediaActions.UPDATE_MEDIA,
      handleUpdateMediaList: MediaActions.UPDATE_MEDIA_LIST,
      handleUpdateAllMediaList: MediaActions.UPDATE_ALL_MEDIA_LIST,
      handleUpdateCategories: MediaActions.UPDATE_CATEGORIES,
      handlePostMedia: MediaActions.POST_MEDIA,
      handleFetchMediaList: MediaActions.FETCH_MEDIA_LIST,
      handleRefreshMediaList: MediaActions.REFRESH_MEDIA_LIST,
      handleRefreshMedia: MediaActions.REFRESH_MEDIA,
      handleUpdateCategoryId: MediaActions.UPDATE_CATEGORY_ID,
      handleUpdateLocationId: MediaActions.UPDATE_LOCATION_ID,
      handleSetLoading: MediaActions.SET_LOADING,
      handleFetchFailed: MediaActions.FETCH_FAILED,
      handleUpdateOffset: MediaActions.UPDATE_OFFSET,
      handleUpdateShareTag: MediaActions.UPDATE_SHARE_TAG,
      handleUpdateFirst: MediaActions.UPDATE_FIRST
    });
  }
  // 设置 loading 状态
  handleSetLoading(loading) {
    this.setState({loading: loading});
  }
  // 根据 media_id 获取 Media 详情
  handleFetchMedia(id) {
    this.state.id = id;
    this.getInstance().getRemoteMedia();
  }
  // 根据 media_id 删除 Media
  handleDeleteMedia(id){
    this.state.id = id;
    this.getInstance().deleteRemoteMedia();
  }
  // 保存 Media 详情
  handleUpdateMedia(media) {
    media.state._id = media.state_id;
    this.state.media = media;
    this.state.lat = media.lat;
    this.state.lng = media.lng;
  }
  // 更新列表 offset
  handleUpdateOffset(offset) {
    this.state.offset = offset; 
  }
  // 更新首页分享标记
  handleUpdateShareTag() {
    this.state.shareTag = false;
  }
  // 获取所有类别
  handleFetchCategories() {
    this.getInstance().getRemoteCategories();
  }
  // 保存类别信息
  handleUpdateCategories(categoryList) {
    this.state.categoryList = categoryList;
  }
  // 发布 Media
  handlePostMedia(media) {
    this.state.postMedia = media;
    this.getInstance().postRemoteMedia();
  }
  // 发布 Media
  handleFetchFailed(err) {
    this.state.errorMsg = err.msg;
  }
  // 发请求追加 MediaList
  handleFetchMediaList() {
    let first = 0;
    if(this.state.page) {
      first = (this.state.page - 1) * this.state.maxCount;
      if(this.state.mediaList.length){
        first += this.state.mediaList.length + 1;
      }else{
        first += 1;
      }
    }else{
      first = this.state.mediaList.length ? this.state.mediaList.length + 1:0;
    }
    this.setState({first: first, loading: true});
    this.getInstance().getRemoteMediaList();
  }
  // 刷新 MediaList
  handleRefreshMediaList() {
    this.setState({mediaList: []});
  }
  // 刷新 Media
  handleRefreshMedia() {
    this.setState({media: {}});
  }
  // 追加 MediaList 新的数据
  handleUpdateMediaList(mediaList) {
    let more = mediaList.length === this.state.maxCount;
    let list = this.state.mediaList.concat(mediaList);
    this.setState({mediaList: list, loading: false, hasMore: more});
  }
  // 更新全部 MediaList
  handleUpdateAllMediaList(mediaList) {
    this.setState({mediaList: mediaList});
  }
  // 根据 category_id 更新 MediaList
  handleUpdateCategoryId(id) {
    this.setState({category_id: id, first: 0, mediaList: []});
    this.getInstance().getRemoteMediaList();
  }
  // 根据 location 信息更新 MediaList
  handleUpdateLocationId(data) {
    let key = `${data.type}_id`;
    let first = (data.page?data.page:0)*this.state.maxCount;
    let newState = {
      page: data.page?data.page:0,
      first: first,
      mediaList: [],
      category_id: data.cid?data.cid:null,
      continent_id: null,
      country_id: null,
      state_id: null,
      city_id: null
    };
    newState[key] = data.id;
    this.setState(newState);
    this.getInstance().getRemoteMediaList();
  }
  // 根据 page 参数更新首条数据
  handleUpdateFirst(page){
    this.setState({page:page});
  }
}

export default alt.createStore(MediaStore, 'MediaStore');



// WEBPACK FOOTER //
// ./src/stores/MediaStore.js